<div class="dialog" *ngIf="!!data">
    <h2 mat-dialog-title class="header">
      <span class="title">{{data.title | translate}}</span>
      <button class="close-ref" mat-icon-button [title]="'general.close' | translate | titlecase" (click)="close()">
        <mat-icon>clear</mat-icon>
      </button>
    </h2>
    <div class="payment-content" mat-dialog-content>
      <!-- Explanation text -->
      <p class="explanation-text" [innerHTML]="'shop.buy_message' | translate : { watermark: 'zonder watermerk'}"></p> 
      <!-- Image/video -->
      <div class="preview-block">
        <div class="price-container">
          <p class="price-display">€ {{data.price}} + € 2 {{"shop.service_costs" | translate}}</p>
        </div>
        <img *ngIf="data.imageUrl" [src]="data.imageUrl" alt="Image" class="dialog-image">
      </div>
      <span class="terms">
        Onze 
        <a href="../../../assets/static/StreApp-Algemene-voorwaarden.pdf" target="_blank">algemene voorwaarden</a>
        zijn van toepassing.
      </span>
    </div>
    <div mat-dialog-actions *ngIf="data.showButton" class="dialog-buttons">
      <button *ngIf="data.showCancelButton" class="close-ref" mat-flat-button [color]="'primary'" [title]="'general.cancel' | translate" (click)="close()">
        {{ 'general.cancel' | translate }}
      </button>
      <button class="close-ref buy-confirm" mat-flat-button [title]="data.buttonText | translate" (click)="closeWithConfirm()">
        {{ data.buttonText | translate }}
      </button>
    </div>
</div>
  
